import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchJobs} from 'sr/utils/api/fetchJobs'
export const fetchJobData = createAsyncThunk(
  'job/fetchJobData',
  async (payload: any) => {
    // Single call with high limit instead of double-fetch pattern
    const response = await fetchJobs({limit: 10000})
    const data: {job_title: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((job: any) => {
      idNameMap[job.id || job._id] = job.job_title
      data.push({
        job_title: job.job_title,
        id: job.id || job._id,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { job } = getState() as { job: { status: string } }
      return job.status !== 'succeeded' && job.status !== 'loading'
    },
  }
)
